export const appInfo = {
  title: 'Vicem Bỉm Sơn',
};
